import { useObserver } from "mobx-react";
import React from "react";
import { useStores } from "../../../store";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Success = () => {
  const { PopupStore, RecuiterStore } = useStores();
  const navigate = useNavigate();
  return useObserver(() => {
    return (
      <>
        {PopupStore.successPopup && (
          <div className=" h-screen w-screen overflow-y-auto z-[500] rounded fixed bottom-0 left-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40 shadow-lg gil-reg overflow-x-hidden no-scrollbar">
            <div className="fixed inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-3xl overflow-y-scroll items-center md:w-[35%]  lg:w-[60%] w-[90%] h-[75%] md:h-[25%] lg:h-[50%] m-auto shadow-lg no-scrollbar">
              <div className="flex flex-col items-center justify-center gap-4 h-full py-5 w-[100%] md:w-[100%] lg:[100%] border">
                <IoCheckmarkCircleOutline className="text-primary w-16 h-16" />
                <p className="text-lg">
                  {" "}
                  Your Resumes are successfully {RecuiterStore.jdType}{" "}
                </p>
                <div className="flex justify-between w-[80%]">
                  <button
                    className="text-primary"
                    onClick={() => {
                      PopupStore.setSuccessPopup(false);
                      navigate("/company/dashboard");
                    }}
                  >
                    {" "}
                    Back to home
                  </button>
                  <button
                    className="bg-primary text-white h-11 w-32 rounded-lg"
                    onClick={() => {
                      PopupStore.setSuccessPopup(false);
                      if (RecuiterStore.jdType === "saved") {
                        navigate(
                          `/company/resumescore/${RecuiterStore.jdID}?save=true`
                        );
                      } else {
                        navigate(`/company/resumescore/${RecuiterStore.jdID}`);
                      }
                    }}
                  >
                    {" "}
                    View now
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  });
};

export default Success;
